import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Create Your Slack Channels`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In Slack add a two new channels:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`ibm-aiops-stories`}</li>
          <li parentName="ul">{`ibm-aiops-change-risk`}</li>
        </ul>
        <img parentName="li" {...{
          "src": "./../images/slack/slack003.png",
          "alt": "slack7"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p>{`You can name the channel whatever you want.`}</p>
    </InlineNotification>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`Right click on each channel and select `}<inlineCode parentName="p">{`Copy Link`}</inlineCode></p>
        <p parentName="li">{`This should get you something like this `}<a parentName="p" {...{
            "href": "https://xxxx.slack.com/archives/C021QOY16BW"
          }}>{`https://xxxx.slack.com/archives/C021QOY16BW`}</a>{`
The last part of the URL is the channel ID (i.e. C021QOY16BW). `}</p>
      </li>
    </ol>
    <InlineNotification kind="warning" mdxType="InlineNotification">	
      <p>{`Write them down for both channels`}</p>
    </InlineNotification>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Under Apps click Browse Apps`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack013.png",
          "alt": "slack7"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the App you just have created`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Invite the Application to each of the two channels by typing`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`@<MyAppname>
`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Select `}<inlineCode parentName="li">{`Add to channel`}</inlineCode></li>
    </ol>
    <p>{`You shoud get a message from `}<inlineCode parentName="p">{`MyAppname`}</inlineCode>{` saying: was added to #your-channel by …`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      